import { render } from "./DocumentSplit.vue?vue&type=template&id=0efbce8a&scoped=true&ts=true"
import script from "./DocumentSplit.vue?vue&type=script&lang=ts"
export * from "./DocumentSplit.vue?vue&type=script&lang=ts"

import "./DocumentSplit.vue?vue&type=style&index=0&id=0efbce8a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efbce8a"]])

export default __exports__